export const splitRuleParams = (rule: string): { ruleName: string; params?: number | string } => {
  const [ruleName, params] = rule.split(':')
  return { ruleName, params: isNaN(Number(params)) ? params : Number(params) }
}

export const getCustomMessageFallback = (defaultMsg: string, customMsg: string): string => {
  return defaultMsg ? customMsg || defaultMsg : defaultMsg
}
